var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "url(#paint0_linear_152_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58009 4.47431L8.50072 4.47345C8.31509 4.47345 8.15697 4.62814 8.15697 4.8172V5.80376C8.15697 6.74391 8.89259 7.5122 9.82072 7.56376C10.1645 8.27274 10.8451 8.78751 11.6562 8.90266V9.45266H10.5975C10.405 9.45266 10.2537 9.60649 10.2537 9.79641V10.7443H9.78625C9.60062 10.7443 9.4425 10.8981 9.4425 11.088V19.3665H8.43875V13.3782C8.43875 13.1883 8.2875 13.0345 8.095 13.0345H3.6675C3.48187 13.0345 3.32375 13.1883 3.32375 13.3782V19.3665H2.375C2.18938 19.3665 2.03125 19.5203 2.03125 19.7102C2.03125 19.9001 2.18938 20.054 2.375 20.054H21.625C21.8175 20.054 21.9687 19.9001 21.9687 19.7102C21.9687 19.5203 21.8175 19.3665 21.625 19.3665H20.6762V15.2319C20.6762 15.042 20.525 14.8882 20.3325 14.8882H15.905C15.7194 14.8882 15.5612 15.042 15.5612 15.2319V19.3665H14.5575V11.088C14.5575 10.8981 14.4062 10.7443 14.2137 10.7443H13.7531V9.79641C13.7531 9.60649 13.595 9.45266 13.4094 9.45266H12.3437V8.90266C13.155 8.7875 13.8356 8.27274 14.1793 7.56376C15.1074 7.51219 15.843 6.74391 15.843 5.80376V4.8172C15.843 4.62815 15.6918 4.47345 15.4993 4.47345H14.4268V4.28955C14.4268 4.09964 14.2687 3.9458 14.083 3.9458H9.92375C9.73125 3.9458 9.58 4.09963 9.58 4.28955L9.58009 4.47431ZM4.01152 19.3663H7.75153V13.722H4.01152V19.3663ZM13.8701 19.3663V11.4318H10.1301V19.3663H13.8701ZM16.2487 19.3663H19.9887V15.5757H16.2487V19.3663ZM13.0654 10.7443V10.1402H10.941V10.7443H13.0654ZM10.2672 6.50418V4.63326H13.739V6.50418C13.739 7.46239 12.9621 8.23926 12.0065 8.23926H11.9996C11.044 8.23926 10.2671 7.46239 10.2671 6.50418H10.2672ZM9.57972 5.16097H8.8441V5.80377C8.8441 6.28502 9.16035 6.69323 9.60035 6.82987C9.5866 6.72331 9.57972 6.61502 9.57972 6.50416V5.16097ZM14.4265 5.16097V6.50418C14.4265 6.61504 14.4196 6.72332 14.4059 6.82989C14.839 6.69325 15.1553 6.28504 15.1553 5.80379V5.16099L14.4265 5.16097Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_2",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189CD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankings);
export default __webpack_public_path__ + "static/media/rankings.4cdb11c273f7aa2d286bcb6a3c63695d.svg";
export { ForwardRef as ReactComponent };